import { Md5 } from "ts-md5/dist/md5";

export const md5 = (input: string) => Md5.hashStr(input).toString();
